import { useLocation } from "react-router-dom";
import { Building2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useEscritorioInfo } from "@/lib/escritorioInfo";

// Lote 157 — aviso discreto quando a tela mostra um item que está na conta de um colega do escritório.
export default function BannerComo() {
  const { search } = useLocation();
  const { user } = useAuth() || {};
  const de = new URLSearchParams(search).get("de");
  const ativo = !!de && de !== user?.user_id;
  const info = useEscritorioInfo(ativo);
  if (!ativo) return null;
  const nome = [...(info?.membros || []), ...(info?.ex_membros || [])].find((m) => m.user_id === de)?.nome;
  return (
    <div data-testid="banner-como" className="mb-4 rounded-lg border border-stone-200 bg-white px-3 py-2 text-xs text-stone-600 flex items-center gap-2">
      <Building2 className="w-4 h-4 text-stone-500 shrink-0" />
      <span>Item da conta de <b>{nome || "um colega"}</b>. O que você alterar aqui fica registrado em nome do escritório.</span>
    </div>
  );
}
